// External dependencies
import jQuery from 'jquery';

jQuery(document).ready(function ($) {
	/**
	 * defined scroll animation function
	 */
	$.easing.jswing = $.easing.swing;

	const pow = Math.pow,
		PI = Math.PI,
		c1 = 1.70158;

	$.extend( $.easing,
		{
			def: 'easeOutQuad',

			easeInOutExpo (x) {
				return x === 0 ? 0 : x === 1 ? 1 : x < 0.5
					? pow( 2, 20 * x - 10 ) / 2
					: ( 2 - pow( 2, -20 * x + 10 ) ) / 2;
			},
		});

	/**
	 * Sideba sticky menu active when scrolling
	 */

	// Cache selectors
	let lastId;
	const sideBarMenuList = $('.table-content-list');

	// All list items
	const menuItems = sideBarMenuList.find('a');
	// Anchors corresponding to menu items
	const getSelectedSectionID = menuItems.map(function() {
		const item = $($(this).attr('href'));
		if (item.length) {
			return item;
		}
	});

	// Bind click handler to menu items
	// so we can get a fancy scroll animation
	menuItems.on('click', function(e) {
		$('.click-table-of-content').removeClass('active');
		const href = $(this).attr('href');
		if (window.matchMedia('(max-width: 767px)').matches) {
			var	offsetTop = href === '#' ? 0 : $(href).offset().top - 157;
		} else {
			var	offsetTop = href === '#' ? 0 : $(href).offset().top - 80;
		}
		$('html, body').stop().animate({
			scrollTop: offsetTop,
		}, 50, 'easeInOutExpo');
		e.preventDefault();
	});

	let initScrollPosition = $(window).scrollTop(),
		table_content_items_height = 0;
	$('.table-content-list li').each(function(index, li) {
		table_content_items_height += parseInt($(li).outerHeight());
		$(li).attr('scroll-position', table_content_items_height );
	});
	let tableContentStickyHeight = $('.table-content-list').outerHeight();
	if (window.matchMedia('(max-width: 767px)').matches) {
		tableContentStickyHeight = $('.mobile-version .table-content-list').outerHeight();
	}

	// Bind to scroll
	$(window).scroll(function() {
		const scrolled = $(window).scrollTop();

		/**
		 * Right side sticky menu active when scrolling
		 */
		// Get container scroll position
		let headerHeight = 85;
		if (window.matchMedia('(max-width: 767px)').matches) {
			headerHeight = 165;
		}

		const fromTop = $(this).scrollTop() + headerHeight;

		// Get id of current scroll item
		let active_section = getSelectedSectionID.map(function() {
			if ($(this).offset().top < fromTop) {
				return this;
			}
		});

		// Get the id of the current element
		active_section = active_section[ active_section.length - 1 ];

		const active_section_id = active_section && active_section.length ? active_section[ 0 ].id : '';

		if (lastId !== active_section_id) {
			lastId = active_section_id;
			// Set/remove active class
			menuItems
				.parent().removeClass('active-menu')
				.end().filter('[href=\'#' + active_section_id + '\']').parent().addClass('active-menu');

			if ($(menuItems.closest('.active-menu')).hasClass('each-third')) {
				const thisUl = $(menuItems.closest('.active-menu'))
					.parent( '.table-content-list' );

				const scrollDownPos = menuItems.closest('.active-menu').prev().prev().attr('scroll-position');
				const scrollUpPos = menuItems.closest('.active-menu').next().attr('scroll-position');
				if ( scrolled > initScrollPosition ) {
				//scrolling down
					$(thisUl).scrollTop( parseInt(scrollDownPos) + 8 ); // 8 is static : for adust actual height
				} else {
					$(thisUl).scrollTop( (parseInt(scrollUpPos) - tableContentStickyHeight ) );
				}
				initScrollPosition = scrolled;
			}
		}

		/**
		 * Reading time sticky in mobile device
		 */
		const window_top = $(window).scrollTop(),
			enable_sticky_tbl_content_nav = $('#enable-sticky-tbl-content-nav').offset().top,
			distance_one = ( enable_sticky_tbl_content_nav - window_top );

		if (distance_one < 94) {
			$('.post-read-time').addClass('fixed-reading-time');
			$('.hidden-post-read-time-height').addClass('active');
			$('.tbl-content-click-btn').addClass('tbl-content-on');
		} else {
			$('.post-read-time').removeClass('fixed-reading-time');
			$('.hidden-post-read-time-height').removeClass('active');
			$('.tbl-content-click-btn').removeClass('tbl-content-on');
			$('.click-table-of-content').removeClass('active');
		}
	});

	/**
	 * Table content click event fire only for mobile device
	 */
	// Toggle TOC on arrow click
	
	  $('.tbl-content-click-btn').on('click', function(e) {
        e.stopPropagation(); 
        $(this).toggleClass('active');
        $('.click-table-of-content').toggleClass('active'); 
    });

    // Close TOC when clicking outside the TOC area (body click)
    $(document).on('click', function() {
        if ($('.click-table-of-content').hasClass('active')) {
            $('.tbl-content-click-btn').removeClass('active');
            $('.click-table-of-content').removeClass('active'); 
        }
    });

    // Prevent closing the TOC when interacting with the TOC itself
    $('.table-content-wrapper').on('click', function(e) {
        e.stopPropagation();
    });

	/**
	 * Desktop table of content display none in mobile device
	 * Direct css : display none making conflict with scroll system in mobile divice
	 */
	if (window.matchMedia('(max-width: 767px)').matches) {
		$('.table-content-wrapper.desktop-version').css({
			display: 'none',
		});
	}
	//  Responsive Sidebar width theiaStickySidebar
	$(window).on('resize', function() {
		var sidebarWidth = $('.left-sidebar-rul').width(); // Get the parent width
		$('.theiaStickySidebar').css('width', sidebarWidth); // Set the sidebar to the same width
	});

	/**
	 * Sticky Sidebar
	 */
	// col-md-3  col-lg-3
	$('.container-content .col-xl-3.left-sidebar-rul').theiaStickySidebar({
		additionalMarginTop: 110,
	});
	/**
	 * FAQ
	 */

	$('.single-faq .faq-title').click( function(e) {
		$('.collapse').collapse('hide');
	});

	/**
	 * Toggle class for sidebar promo
	 */
	$('.close-arrow').on('click', function() {
		if ($('.side-scrolling-promo-bar').find('#desktop_player').length !== 0) {
		//youtube video pause
			desktop_player.pauseVideo();
			mobile_player.pauseVideo();
		}

		//Hide Siebar promo box
		$('.side-scrolling-promo-bar').removeClass('show');
		$('.mobile-promo-box').removeClass('show');
	});
	/**
	 * Click for Expand Sidebar promo box
	 */
	$('.side-scrolling-promo-bar-btn').on('click', function() {
	//show sidebar promo box
		$('.side-scrolling-promo-bar').addClass('show');
		$('.mobile-promo-box').addClass('show');

		if ($('.side-scrolling-promo-bar').find('#desktop_player').length !== 0) {
		//youtube video play
			desktop_player.playVideo();
			mobile_player.playVideo();
		}
	});

	/**
	 * Top reading progressbar
	 */

	const total_reading_time = parseInt($('.remaing-time').text());
	let promo_event_fire = false;
	const processScroll = () => {
		const win = $(window),
			doc = $('.post-content'),
			setPercent = () => (win.scrollTop() / (doc.height() - win.height()) * 100);

		document.getElementById('progress-bar').style.setProperty('--scrollAmount', setPercent() + '%');
		//Time calculator when page scrolling
		const time_span = $('.remaing-time'),
			remain_time = Math.floor(total_reading_time - (total_reading_time / (100 / setPercent())));

		if (remain_time > 1) {
			time_span.text(remain_time);
		} else {
			time_span.text('<1');
		}
		// promo bar showing once when page scrolling
		if ( setPercent() > 20 && ! promo_event_fire ) {
			if ($('.side-scrolling-promo-bar').find('#desktop_player').length !== 0) {
				desktop_player.playVideo(); //youtube video play - sidebar promo
			}
			$('.side-scrolling-promo-bar').addClass('show');
			setTimeout(() => {
				$('.side-scrolling-promo-bar-btn').css({ display: 'block' });
			}, 2000);

			promo_event_fire = true;
		}
		// sidebar show when content div scrolled 5%
		if ( setPercent() > 3 ) {
			$('.sidebar-newsletter').addClass('show');
		}
		if ( setPercent() > 99 || setPercent() < 3) {
			$('.sidebar-newsletter').removeClass('show');
		}
	};
	//Scroll event fire : processScroll
	document.addEventListener('scroll', processScroll);

	//Comment scroll animation
	$('.rul-comment-link').on('click', function(e) {
		const commentSection = $('#comments').offset().top - 20;
		$('html, body').stop().animate({
			scrollTop: commentSection,
		}, 1000, 'easeInOutExpo');
	//e.preventDefault();
	});

	/**
	 * Clickable CTA Box
	 * CTA Block by gutenberg
	 * Footer CTA Box
	 */
	$('.single-box h3, .single-box .h3').each(function(index, item) {
		const thisBox = $(item);
		if (thisBox.has('a').length > 0) {
			thisBox.addClass('clickable-box');
			let link = thisBox.children('a').attr('href'),
				target = '';
			target = thisBox.children('a').attr('target');
			if (target == '_blank') {
				target = '_blank';
			} else {
				target = '_self';
			}
			thisBox.on('click', function() {
				window.open( link, target);
			});
		}
	});
});

/*
 * Comment Form : Vallidation and Ajax part
 *
 * Let's begin with validation functions
 */
jQuery.extend(jQuery.fn, {
	/*
	 * check name field
	 */
	validate () {
		if (jQuery(this).val().length === 0 ) {
			jQuery(this).addClass('error-comment-field');

			jQuery(this).next().text('Name is required');
			jQuery(this).next().addClass('show-message');
			//alert('name error');
			return false;
		} else if (jQuery(this).val().length < 3) {
			jQuery(this).addClass('error-comment-field');

			jQuery(this).next().text('Name minimum character is 3');
			jQuery(this).next().addClass('show-message');
			//alert('name error');
			return false;
		}

		jQuery(this).removeClass('error-comment-field');
		jQuery(this).next().removeClass('show-message');
		jQuery(this).next().text('');
		//alert('no name error');
		return true;
	},
	/**
	 * Check comment field
	 */
	validateComment () {
		if (jQuery(this).val().length === 0 ) {
			jQuery(this).addClass('error-comment-field');
			jQuery(this).next().text('Comment is required');
			jQuery(this).next().addClass('show-message');
			//alert('comment error');
			return false;
		} else if (jQuery(this).val().length < 3) {
			jQuery(this).addClass('error-comment-field');
			jQuery(this).next().text('Comment minimum character is 3');
			jQuery(this).next().addClass('show-message');
			//alert('comment error');
			return false;
		}

		jQuery(this).removeClass('error-comment-field');
		jQuery(this).next().removeClass('show-message');
		jQuery(this).next().text('');
		//alert('no comment error');
		return true;
	},
	/*
	 * check email field
	 */
	validateEmail () {
		//var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?jQuery/,
		const emailReg = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/,
		    emailToValidate = jQuery(this).val();
		if (emailToValidate === '') {
			jQuery(this).addClass('error-comment-field');
			jQuery(this).next().text('Email is required');
			jQuery(this).next().addClass('show-message');
			//alert('email error');
			return false;
		} else if (!emailReg.test( emailToValidate )) {
			jQuery(this).addClass('error-comment-field');
			jQuery(this).next().text('Enter a valid Email address');
			jQuery(this).next().addClass('show-message');
			//alert('email error');
			return false;
		}

		jQuery(this).removeClass('error-comment-field');
		jQuery(this).next().removeClass('show-message');
		jQuery(this).next().text('');
		//alert('no email error');
		return true;
	},
	/**
	 * check url field
	 * @return true or false
	 */
	validateURL() {
		const urlReg = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/,
		    urlToValidate = jQuery(this).val();
		if ( urlToValidate == '' ) {
			jQuery(this).removeClass('error-comment-field');
			jQuery(this).next().removeClass('show-message');
			jQuery(this).next().text('');
			return true;
		} else if ( ! urlReg.test( urlToValidate ) ) {
			jQuery(this).addClass('error-comment-field');
			jQuery(this).next().text('Enter a valid url');
			jQuery(this).next().addClass('show-message');
			//alert('email error');
			return false;
		}
		jQuery(this).removeClass('error-comment-field');
		jQuery(this).next().removeClass('show-message');
		jQuery(this).next().text('');
		return true;
	},
});
/**
 * Comment : Ajax part
 */
jQuery(function($) {
	/**
	 * append error wrapper
	 */
	$('.comment-form-comment label').append('<span class="required">*</span>');
	$('.comment-form-comment').append('<span class="comment-field-error-message">.</span>');
	$('.comment-form-author').append('<span class="comment-field-error-message">.</span>');
	$('.comment-form-email').append('<span class="comment-field-error-message">.</span>');
	$('.comment-form-url').append('<span class="comment-field-error-message">.</span>');

	$('.form-submit').after('<p class="comment-message comment-success-message">Comment added successfully</p>');
	/*
	 * On comment form submit
	 */
	$( '#commentform' ).submit(function() {
		// define some vars
		const button = $('#submit'), // submit button
		    respond = $('#respond'), // comment form container
		    commentlist = $('.comment-list'), // comment list container
		    cancelreplylink = $('#cancel-comment-reply-link');

		// if user is logged in, do not validate author and email fields
		// validate comment in any case
		$( '#comment' ).validateComment();

		if ( $( '#author' ).length ) {
			$( '#author' ).validate();
		}

		if ( $( '#email' ).length ) {
			$( '#email' ).validateEmail();
		}

		$( '#url' ).validateURL();

		// if comment form isn't in process, submit it
		if ( !button.hasClass( 'loadingform' ) && !$( '#author' ).hasClass( 'error-comment-field' ) && !$( '#email' ).hasClass( 'error-comment-field' ) && !$( '#url' ).hasClass( 'error-comment-field' ) && !$( '#comment' ).hasClass( 'error-comment-field' ) ) {
			// ajax request
			$.ajax({
				type: 'POST',
				url: window.RETO_AjaxCommentParams.ajaxurl, // admin-ajax.php URL
				data: $(this).serialize() + '&action=ajaxcomments', // send form data + action parameter
				beforeSend(xhr) {
					// what to do just after the form has been submitted
					button.addClass('loadingform').val('Loading...');
				},
				error (request, status, error) {
					if ( status == 500 ) {
						alert( 'Error while adding comment' );
					} else if ( status == 'timeout' ) {
						alert('Error: Server doesn\'t respond.');
					} else {
						// process WordPress errors
						const wpErrorHtml = request.responseText.split('<p>'),
							wpErrorStr = wpErrorHtml[ 1 ].split('</p>');

						alert( wpErrorStr[ 0 ] );
					}
				},
				success ( addedCommentHTML ) {
					// if this post already has comments
					if ( commentlist.length > 0 ) {
						// if in reply to another comment
						if ( respond.parent().hasClass( 'comment' ) ) {
							// if the other replies exist
							if ( respond.parent().children( '.children' ).length ) {
								respond.parent().children( '.children' ).append( addedCommentHTML );
							} else {
								// if no replies, add <ol class="children">
								addedCommentHTML = '<ol class="children">' + addedCommentHTML + '</ol>';
								respond.parent().append( addedCommentHTML );
							}
							// close respond form
							cancelreplylink.trigger('click');
						} else {
							// simple comment
							commentlist.append( addedCommentHTML );
						}
					} else {
						// if no comments yet
						addedCommentHTML = '<ol class="comment-list">' + addedCommentHTML + '</ol>';
						respond.before( $(addedCommentHTML) );
					}
					// clear textarea field
					$('#comment').val('');
					// $('#author').val('');
					// $('#email').val('');
					// $('#url').val('');
					$('.comment-field-error-message').removeClass('show-message');
					$('.comment-field-error-message').text('.');
					$('.comment-success-message').addClass('show-message');
				},
				complete() {
					// what to do after a comment has been added
					button.removeClass( 'loadingform' ).val( 'Post Comment' );
				},
			});
		}
		return false;
	});

	/**
	 * success message remove when click on reply button
	 */
	$('.comment-reply-link').on('click', function() {
		$('.comment-success-message').removeClass('show-message');
	});
});

